import styled from 'styled-components';

export const SubTitle = styled('p')`
  color: #4d4d4d;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ResendCodeStyled = styled.a`
  display: inline-block;

  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;

  color: #262ba6;

  cursor: pointer;
`;

export const CodeMessage = styled.p`
  display: inline-block;

  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
`;

export const Title = styled('h2')`
  color: #4d4d4d;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
